import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";

const LINKS = {
  guest: [["/events", "Event"], ["/non-event", "Non Event"], ["/studio", "Fotografer"], ["/cari", "Cari Wajah"]],
  member: [["/events", "Event"], ["/non-event", "Non Event"], ["/studio", "Fotografer"], ["/cari", "Cari Wajah"], ["/pesanan", "Pesanan"], ["/koleksi", "Koleksi Saya"]],
  photographer: [["/fotografer", "Dashboard"], ["/fotografer/pesanan", "Pesanan Masuk"], ["/fotografer/paket", "Paket"], ["/fotografer/promo", "Promo"], ["/fotografer/profil", "Profil & Rekening"]],
  admin: [["/admin", "Admin"], ["/fotografer/pesanan", "Semua Pesanan"], ["/events", "Event"], ["/non-event", "Non Event"]],
};

export const Navbar = () => {
  const { user, logout } = useAuth();
  const { items } = useCart();
  const nav = useNavigate();
  const links = LINKS[user ? user.role : "guest"];

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-zinc-200" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-8">
        <Link to="/" className="group flex items-center gap-2 font-display font-extrabold text-lg tracking-tight" data-testid="nav-logo">
          <img src="/logo.svg" alt="" className="h-8 w-8 transition-transform duration-300 group-hover:rotate-6" data-testid="nav-logo-mark" />
          Akudifoto
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map(([to, label]) => (
            <NavLink key={to} to={to} end data-testid={`nav-link-${to.replace(/\//g, "-").slice(1) || "home"}`}
              className={({ isActive }) => `px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? "text-blue-600 bg-blue-50" : "text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100"}`}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-2">
          {(!user || user.role === "member") && (
            <Link to="/keranjang" className="relative p-2 rounded-lg hover:bg-zinc-100 transition-colors" data-testid="nav-cart-button">
              <ShoppingBag className="h-5 w-5 text-zinc-700" />
              {items.length > 0 && (
                <span className="absolute -top-0.5 -right-0.5 h-5 min-w-5 px-1 rounded-full bg-blue-600 text-white text-[11px] font-bold grid place-items-center" data-testid="nav-cart-count">{items.length}</span>
              )}
            </Link>
          )}
          {user ? (
            <>
              <span className="hidden sm:block text-sm text-zinc-500" data-testid="nav-user-name">{user.name}</span>
              <Button variant="ghost" size="icon" onClick={async () => { await logout(); nav("/"); }} data-testid="nav-logout-button"><LogOut className="h-4 w-4" /></Button>
            </>
          ) : (
            <>
              <Button variant="ghost" asChild data-testid="nav-login-button"><Link to="/login">Masuk</Link></Button>
              <Button asChild className="rounded-xl bg-zinc-900 hover:bg-zinc-800" data-testid="nav-register-button"><Link to="/register">Daftar</Link></Button>
            </>
          )}
        </div>
      </div>
      <nav className="md:hidden flex gap-1 overflow-x-auto px-4 pb-2">
        {links.map(([to, label]) => (
          <NavLink key={to} to={to} end className="px-3 py-1.5 rounded-lg text-xs font-medium text-zinc-600 whitespace-nowrap bg-zinc-100">{label}</NavLink>
        ))}
      </nav>
    </header>
  );
};
